export default __webpack_public_path__ + "static/media/autoportrait.10acebc9.jpg";